// import { useTranslations } from 'next-intl'
// // import { type Locale } from '@/navigation'

// import {type Locale } from '@/navigation'

// interface PaginationProps {
//   totalPages: number
//   currentPage: number
//   onPageChange: (page: number) => void
//   params: { locale: Locale }
// }
// export default function Pagination({
//   totalPages,
//   currentPage,
//   onPageChange,
//   params: { locale },
// }: PaginationProps) {
//   const  t  = useTranslations('blog.home')
//   const prevPage = currentPage - 1 > 0
//   const nextPage = currentPage + 1 <= totalPages

//   const handlePrevPage = () => {
//     if (prevPage) {
//       onPageChange(currentPage - 1)
//     }
//   }

//   const handleNextPage = () => {
//     if (nextPage) {
//       onPageChange(currentPage + 1)
//     }
//   }

//   return (
//     <div className="space-y-2 pb-8 pt-6 md:space-y-5">
//       <nav className="flex justify-between">
//         {!prevPage && (
//           <button className="cursor-auto disabled:opacity-50" disabled={!prevPage}>
//             {t('prevp')}
//           </button>
//         )}
//         {prevPage && <button onClick={handlePrevPage}> {t('prevp')}</button>}
//         <span>
//           {currentPage} of {totalPages}
//         </span>
//         {!nextPage && (
//           <button className="cursor-auto disabled:opacity-50" disabled={!nextPage}>
//             {t('nextp')}
//           </button>
//         )}
//         {nextPage && <button onClick={handleNextPage}>{t('nextp')}</button>}
//       </nav>
//     </div>
//   )
// }


import React from 'react';
import { useTranslations } from 'next-intl';
import { type Locale } from '@/navigation';
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  params: { locale: Locale };
}

export default function Pagination({
  totalPages,
  currentPage,
  onPageChange,
  params: { locale },
}: PaginationProps) {
  const t = useTranslations('blog.home');
  const prevPage = currentPage - 1 > 0;
  const nextPage = currentPage + 1 <= totalPages;

  const handlePrevPage = () => {
    if (prevPage) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (nextPage) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex items-center justify-between py-6">
      <Button
        variant="ghost"
        size="sm"
        onClick={handlePrevPage}
        disabled={!prevPage}
      >
        <ChevronLeft className="h-4 w-4 mr-2" />
        {t('prevp')}
      </Button>
      <span className="text-sm font-medium">
        {t('page')} {currentPage} {t('of')} {totalPages}
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleNextPage}
        disabled={!nextPage}
      >
        {t('nextp')}
        <ChevronRight className="h-4 w-4 ml-2" />
      </Button>
    </div>
  );
}
